import { createFileRoute, redirect } from '@tanstack/react-router';

/** Old top-level path; agent lives under Settings now. */
export const Route = createFileRoute('/agent')({
  beforeLoad: () => {
    throw redirect({ to: '/settings/agent', replace: true });
  }
});
